export default __webpack_public_path__ + "static/media/truck1.7ab97163.png";